import React from 'react'
import '../styles/components/SalesDeck.css'

const SalesDeck = () => {
  return (
    <section id="sales-deck" className="sales-deck">
      <div className="section-container">

        {/* Header */}
        <div className="section-header">
          <span className="section-badge">Enterprise Solutions</span>
          <h2 className="section-title">Digital Operations & Compliance Transformation</h2>
          <p className="section-subtitle">
            Transforming organizations through end-to-end digitization and compliance-ready systems
          </p>
        </div>

        <div className="sales-deck-content">
          {/* Problem vs Solution - Side by Side */}
          <div className="deck-row hero-row">
            <div className="versus-container">
              {/* Problem Side */}
              <div className="versus-block problem-side">
                <div className="versus-header">
                  <span className="versus-label problem-label">Without FIGO</span>
                  <h3>The Problem</h3>
                </div>
                <ul className="versus-list">
                  <li>
                    <span className="versus-icon problem-icon">✕</span>
                    <span>Manual processes slowing operations</span>
                  </li>
                  <li>
                    <span className="versus-icon problem-icon">✕</span>
                    <span>Inconsistent data across systems</span>
                  </li>
                  <li>
                    <span className="versus-icon problem-icon">✕</span>
                    <span>Audit failures & compliance gaps</span>
                  </li>
                  <li>
                    <span className="versus-icon problem-icon">✕</span>
                    <span>Operational inefficiencies</span>
                  </li>
                  <li>
                    <span className="versus-icon problem-icon">✕</span>
                    <span>Funding & scale limitations</span>
                  </li>
                </ul>
                <div className="cost-badge">
                  <span className="cost-title">Cost of Inaction:</span>
                  <ul className="cost-list">
                    <li>💸 Losing ₦10M+ annually to inefficiencies</li>
                    <li>⏰ Staff wasting 40% of time on manual tasks</li>
                    <li>📉 Failed audits blocking funding opportunities</li>
                    <li>🚫 Competitors scaling while you're stuck</li>
                  </ul>
                </div>
              </div>

              {/* VS Divider */}
              <div className="versus-divider">
                <span className="vs-text">VS</span>
                <div className="arrow-right"></div>
              </div>

              {/* Solution Side */}
              <div className="versus-block solution-side">
                <div className="versus-header">
                  <span className="versus-label solution-label">With FIGO</span>
                  <h3>The Solution</h3>
                </div>
                <ul className="versus-list">
                  <li>
                    <span className="versus-icon solution-icon">✓</span>
                    <span>Automated workflows & digital processes</span>
                  </li>
                  <li>
                    <span className="versus-icon solution-icon">✓</span>
                    <span>Unified data architecture & single source of truth</span>
                  </li>
                  <li>
                    <span className="versus-icon solution-icon">✓</span>
                    <span>Compliance-ready systems & audit trails</span>
                  </li>
                  <li>
                    <span className="versus-icon solution-icon">✓</span>
                    <span>Streamlined operations & cost reduction</span>
                  </li>
                  <li>
                    <span className="versus-icon solution-icon">✓</span>
                    <span>Scalable infrastructure for growth</span>
                  </li>
                </ul>
                <div className="benefit-badge">
                  <span className="benefit-title">The Result:</span>
                  <ul className="benefit-list">
                    <li>✅ 40% reduction in operational costs</li>
                    <li>✅ 3x faster report generation & decisions</li>
                    <li>✅ 100% audit-ready at any moment</li>
                    <li>✅ Scale confidently with investor-grade systems</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Process Block */}
          <div className="deck-row process-row">
            <div className="deck-block process-block">
              <div className="block-header centered">
                <h3>How It Works</h3>
              </div>
              <div className="process-timeline">
                <div className="process-step">
                  <div className="step-number">1</div>
                  <div className="step-content">
                    <h4>Assessment</h4>
                    <p>Deep dive into your current operations</p>
                  </div>
                </div>
                <div className="process-connector"></div>
                <div className="process-step">
                  <div className="step-number">2</div>
                  <div className="step-content">
                    <h4>System Design</h4>
                    <p>Custom solution architecture</p>
                  </div>
                </div>
                <div className="process-connector"></div>
                <div className="process-step">
                  <div className="step-number">3</div>
                  <div className="step-content">
                    <h4>Implementation</h4>
                    <p>Phased rollout with minimal disruption</p>
                  </div>
                </div>
                <div className="process-connector"></div>
                <div className="process-step">
                  <div className="step-number">4</div>
                  <div className="step-content">
                    <h4>Training</h4>
                    <p>Comprehensive team enablement</p>
                  </div>
                </div>
                <div className="process-connector"></div>
                <div className="process-step">
                  <div className="step-number">5</div>
                  <div className="step-content">
                    <h4>Ongoing Support</h4>
                    <p>Continuous optimization & assistance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SalesDeck
